import { FileUploadContext } from "@/components/common/file-upload-context/file-uploads-context";
import { PickersLocalizationProvider } from "@/components/common/pickers-localization-provider";
import { ElementFileUploadContext } from "@/components/common/point-cloud-file-upload-context/element-file-upload-context";
import { ProjectLoadingContext } from "@/components/common/project-provider/project-loading-context";
import { SceneEventsContext } from "@/components/common/scene-events-context";
import { SettingsContext } from "@/components/common/settings-context/settings-context";
import { ViewRuntimeContext } from "@/components/common/view-runtime-context";
import { ErrorHandlersContext } from "@/errors/components/error-handling-context";
import { ModeDataContext } from "@/modes/mode-data-context";
import { ThresholdSetContext } from "@/registration-tools/common/registration-report/threshold-set-context";
import { DialogContext, ToastContext } from "@faro-lotv/flat-ui";
import { AuthContext } from "@faro-lotv/gate-keepers";
import { ApiClientContext } from "@faro-lotv/service-wires";
import { useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/system";
import { useContextBridge } from "@react-three/drei";
import { Html, HtmlProps } from "@react-three/drei/web/Html";
import type { JSX } from "react";
import { ReactReduxContext } from "react-redux";

/**
 * @returns an Html component that correctly bridge all the App contexts inside (theme too)
 */
export function AppAwareHtml({ children, ...rest }: HtmlProps): JSX.Element {
  const theme = useTheme();

  const ContextBridge = useContextBridge(
    ApiClientContext,
    AuthContext,
    DialogContext,
    ElementFileUploadContext,
    ErrorHandlersContext,
    FileUploadContext,
    ProjectLoadingContext,
    ModeDataContext,
    ReactReduxContext,
    ToastContext,
    ViewRuntimeContext,
    SceneEventsContext,
    SettingsContext,
    ThresholdSetContext,
  );

  return (
    <Html {...rest}>
      <ContextBridge>
        {/* Material's provider would add a second color-scheme root, a THEME_ID scope would hide the theme from @mui/system components */}
        <ThemeProvider theme={theme}>
          <PickersLocalizationProvider>{children}</PickersLocalizationProvider>
        </ThemeProvider>
      </ContextBridge>
    </Html>
  );
}
